module.exports = __webpack_public_path__ + "static/media/rupee_deposit_icon.cb0fb56c.svg";